export function getGroupByKey(state) {
  return (key) => getFlatGroups(state)[key];
}

export function getFlatGroups(state) {
  const groups = [];
  const process = (nodes) => {
    nodes.forEach((node) => {
      groups[node.key] = node;
      return process(node.children);
    });
  };
  process(state.groups);
  return groups;
}

export function groupsWithAccount(state) {
  return [
    {
      key: 'root',
      name: '(Your Account)',
      children: state.groups,
      treeDepth: 0,
      disable: true,
      selectionForbidden: true,
    },
  ];
}
